import { createAction } from '@reduxjs/toolkit';

export const instagramUpdateId = createAction('instagram/updateId');
export const instagramUpdateIsAdded = createAction('instagram/updateIsAdded');
export const instagramUpdateIsActive = createAction('instagram/updateIsActive');

export const instagramStore = createAction('instagram/store');
export const instagramClear = createAction('instagram/clear');

export const instagramUpdateRequest = createAction('instagram/updateRequest');
export const instagramUpdateError = createAction('instagram/updateError');
export const instagramUpdateStore = createAction('instagram/updateStore');

export const instagramUpdateItems = createAction('instagram/updateItems');
export const instagramUpdateLists = createAction('instagram/updateLists');

export const instagramUpdateConnect = createAction('instagram/updateConnect');
export const instagramUpdateLayout = createAction('instagram/updateLayout');
export const instagramUpdateView = createAction('instagram/updateView');

export const instagramUpdateHeadingTitle = createAction('instagram/updateHeadingTitle');
export const instagramUpdateHeadingDescription = createAction('instagram/updateHeadingDescription');
export const instagramUpdateHeadingTextAlign = createAction('instagram/updateHeadingTextAlign');
export const instagramUpdateHeadingImage = createAction('instagram/updateHeadingImage');
export const instagramUpdateHeadingDivider = createAction('instagram/updateHeadingDivider');

export const instagramUpdateSectionIsBackground = createAction('instagram/updateSectionIsBackground');
export const instagramUpdateSectionTextColor = createAction('instagram/updateSectionTextColor');
export const instagramUpdateSectionBackgroundColor = createAction('instagram/updateSectionBackgroundColor');
export const instagramUpdateSectionOpacity = createAction('instagram/updateSectionOpacity');
export const instagramUpdateSectionIsFullWidth = createAction('instagram/updateSectionIsFullWidth');
export const instagramUpdateSectionShadow = createAction('instagram/updateSectionShadow');
export const instagramUpdateSectionShadowColor = createAction('instagram/updateSectionShadowColor');
export const instagramUpdateSectionPadding = createAction('instagram/updateSectionPadding');
export const instagramUpdateSectionMargin = createAction('instagram/updateSectionMargin');
export const instagramUpdateSectionBackgroundType = createAction('instagram/updateSectionBackgroundType');
export const instagramUpdateSectionBackgroundImage = createAction('instagram/updateSectionBackgroundImage');
export const instagramUpdateSectionGradientColor1 = createAction('instagram/updateSectionGradientColor1');
export const instagramUpdateSectionGradientColor2 = createAction('instagram/updateSectionGradientColor2');
export const instagramUpdateSectionGradientDirection = createAction('instagram/updateSectionGradientDirection');
export const instagramUpdateSectionGradientOffset = createAction('instagram/updateSectionGradientOffset');
export const instagramUpdateSectionBorder = createAction('instagram/updateSectionBorder');
export const instagramUpdateSectionBorderColor = createAction('instagram/updateSectionBorderColor');
export const instagramUpdateSectionShadowBorderColor = createAction('instagram/updateSectionShadowBorderColor');
export const instagramUpdateSectionShape = createAction('instagram/updateSectionShape');

export const instagramUpdateItemShadow = createAction('instagram/updateItemShadow');
export const instagramUpdateItemShadowColor = createAction('instagram/updateItemShadowColor');
export const instagramUpdateItemBorder = createAction('instagram/updateItemBorder');
export const instagramUpdateItemBorderColor = createAction('instagram/updateItemBorderColor');
export const instagramUpdateItemShape = createAction('instagram/updateItemShape');
